import {
    CalendarPlanActivity,
    CalendarPlanShowcaseConfigGivenOutStatus as LessonGiveOutStatus,
    Lesson,
} from '@yandex-int/k-common';
import { CONTENT_TYPE, LessonViewSettings } from '@yandex-int/k-common/typings/api/models/content';
import { isWithinInterval } from 'date-fns';
import { ShowcaseLesson } from 'platform-components/src/components/showcase-card/schowcase-card';

import { LessonWithDetails } from '../calendar-plan-showcase/typings';

interface CalendarPlanThemeCardData {
    period: {
        start_date: string;
        end_date: string;
    };
    lessonViewSettings: LessonViewSettings;
    lesson: Lesson | null;
    lessonDetails?: LessonWithDetails[] | null;
}

export function mapToCalendarPlanShowcaseCard(data: CalendarPlanThemeCardData): ShowcaseLesson {
    const { lessonViewSettings, period, lesson, lessonDetails } = data;
    const {
        image,
        background: backgroundColor,
        skills,
        description,
        teachers_evaluation: teachersEvaluation,
    } = lessonViewSettings;
    const today = Date.now();
    const isLessonAssigned = lessonDetails?.some(
        ({ id, assigned_count: assignedCount }) => id === lesson?.id && assignedCount
    );

    return {
        id: Number(lesson?.id),
        name: lesson?.name || '',
        enabled: true,
        canBeGiven: true,
        isLessonBeingGivenNow: isWithinInterval(today, {
            start: new Date(period.start_date),
            end: new Date(period.end_date),
        }),
        status: isLessonAssigned ? LessonGiveOutStatus.GIVENOUT : LessonGiveOutStatus.AVAILABLE,
        image,
        backgroundColor,
        content: {
            skills: skills || '',
            description: description || '',
            teacherMark: teachersEvaluation?.toFixed(1) || '',
        },
    };
}

export function getLessonActivity(activities?: CalendarPlanActivity[]) {
    const item = activities?.find(({ content_type }) => content_type === CONTENT_TYPE.LESSON);

    if (item?.content_type === CONTENT_TYPE.LESSON) {
        return item;
    }

    return null;
}
